import { ApiClient } from "./ApiClient";

export interface NewsListing {
    Title?: string;
    Url?: string;
    PublishDateFormatted?: string;
    ThumbnailImageSRC?: string;
    ThumbnailImageDAM?: unknown;
    ThumbnailImageDAMCropData?: unknown;
    ThumbnailImageAltText?: string;
    DefaultImageSRC?: string;
    DefaultImageAltText?: string;
}

export interface NewsListingsPageData {
    newsListings: NewsListing[];
    totalPages: number;
    totalNewsListings: number;
    relevantYears: number[];
}

export interface NewsListingsQueryParams {
    [key: string]: string | number | undefined;
    pageID: string;
    page: number;
    year?: string;
    lang?: string;
}

export class NewsListingApi {
    private apiClient = new ApiClient("/api/newslistings");

    getNewsListings(params: NewsListingsQueryParams) {
        return this.apiClient.get<NewsListingsPageData>("pageData", params);
    }
}

export const newsListingsApi = new NewsListingApi();
